// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, multipart } from '../../../../common/api'
import { EXPENSES, ADD_EXPENSES, GET_EXPENSES, EDIT_EXPENSES, DELETE_EXPENSES } from '../../../../common/constant'

export const actionExpenses = createAsyncThunk('appExpenses/actionExpenses', async (params, thunkAPI) => {
    return await post(EXPENSES, params, thunkAPI)
})

export const actionAddExpenses = createAsyncThunk('appExpenses/actionAddExpenses', async (params, thunkAPI) => {
    return await multipart(ADD_EXPENSES, params, thunkAPI)
})

export const actionGetExpenses = createAsyncThunk('appExpenses/actionGetExpenses', async (params, thunkAPI) => {
    return await post(GET_EXPENSES, params, thunkAPI)
})

export const actionEditExpenses = createAsyncThunk('appExpenses/actionEditExpenses', async (params, thunkAPI) => {
    return await multipart(EDIT_EXPENSES, params, thunkAPI)
})

export const actionDeleteExpenses = createAsyncThunk('appExpenses/actionDeleteExpenses', async (params, thunkAPI) => {
    return await post(DELETE_EXPENSES, params, thunkAPI)
})


export const appExpensesSlice = createSlice({
    name: 'appExpenses',
    initialState: {
        //list
        loading: false,
        expenses: null,

        //add
        loadingAdd: false,
        addExpenses: null,

        //get
        loadingGet: false,
        getExpenses: null,

        //edit
        loadingEdit: false,
        editExpenses: null,

        //delete
        loadingDelete: false,
        deleteExpenses: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetExpensesResponse: (state) => {
            state.expenses = null
        },
        resetAddExpensesResponse: (state) => {
            state.addExpenses = null
        },
        resetGetExpensesResponse: (state) => {
            state.getExpenses = null
        },
        resetEditExpensesResponse: (state) => {
            state.editExpenses = null
        },
        resetDeleteExpensesResponse: (state) => {
            state.deleteExpenses = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionExpenses.pending, (state) => {
                state.loading = true
            })
            .addCase(actionExpenses.fulfilled, (state, action) => {
                state.loading = false
                state.expenses = action.payload
            })
            .addCase(actionExpenses.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddExpenses.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddExpenses.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addExpenses = action.payload
            })
            .addCase(actionAddExpenses.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetExpenses.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetExpenses.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getExpenses = action.payload
            })
            .addCase(actionGetExpenses.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditExpenses.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditExpenses.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editExpenses = action.payload
            })
            .addCase(actionEditExpenses.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteExpenses.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteExpenses.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteExpenses = action.payload
            })
            .addCase(actionDeleteExpenses.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetExpensesResponse, resetAddExpensesResponse, resetGetExpensesResponse, resetEditExpensesResponse, resetDeleteExpensesResponse } = appExpensesSlice.actions

export default appExpensesSlice.reducer